const component = Object.assign({}, {
    hm: null,
    element: null,
    id: '',
    htmlElementName: '',
    componentType: '',
    configHash: null,
    formId: '',
    initialValue: null,
    rawValue: null,
    readOnly: false,
    defaultValue: false,
    isHidden: false,
    notSubmittable: false,
    hiddenValue: false,
    extraAttributes: {},
    subelements: {
        validationMessage: null
    },
    holder: null,
    timers: {},
    blocked: false,
    blockedReasons: [],
    hiddenByFilters: {},
    valid: true,
    validationResults: [],
    validationTriggeringEvents: ['change'],
    changeEvents: ['change'], //events to trigger after element value change programatically
    filteredBy: {},

    init: function () {
        this.holder = document.querySelector('[data-zit-holder-for="' + this.id + '"]');
        let form = this.element.closest('form');
        if (form !== null) {
            this.formId = form.getAttribute('id');
        }
        this.readZAttributes();

        if (!this.htmlElementName && typeof this.element.name !== typeof undefined) {
            this.htmlElementName = this.element.name;
        }

        this.initSubelements();
        this.initValidation();
        //sometimes we load an initialValue via thee data-zit-initial-value attribute
        if (this.initialValue === null) {
            this.initialValue = this.getValue();
        }
    },

    inited: function () {

    },

    initSubelements: function (subelementType = false) {
        let subelements = document.querySelectorAll('[data-zit-subelement-for="' + this.id + '"]');

        subelements.forEach((subelement) => {
            let currentSubelementType = subelement.dataset.zitSubelementType;
            if (subelementType === false || subelementType === currentSubelementType) {
                if (typeof this.subelements[currentSubelementType] !== typeof undefined && Array.isArray(this.subelements[currentSubelementType])) {
                    this.subelements[currentSubelementType].push(subelement);
                } else {
                    this.subelements[currentSubelementType] = subelement;
                }
            }
        });
    },

    hasSubelement: function (subelement) {
        return typeof this.subelements[subelement] !== typeof undefined && this.subelements[subelement] !== null;
    },

    initValidation: function () {
        let validationRules = this.readZAttribute('validation', {});

        if (Object.keys(validationRules).length) {
            this.hm.validator.loadRules(this, validationRules);
            this.validationTriggeringEvents.forEach((triggeringEvent) => {
                this.element.addEventListener(triggeringEvent, () => {
                    this.startTimer('validation', () => {
                        this.validate();
                    })
                });
            });
        }
    },

    startTimer: function (timerType, callback, timeout = 1500) {
        if (typeof this.timers[timerType] !== typeof undefined && this.timers[timerType] !== false) {
            clearTimeout(this.timers[timerType]);
            this.timers[timerType] = false;
        }

        this.timers[timerType] = setTimeout(callback, timeout);
    },

    clearTimer: function (timerType) {
        if (typeof this.timers[timerType] !== typeof undefined && this.timers[timerType] !== false) {
            clearTimeout(this.timers[timerType]);
            this.timers[timerType] = false;
            delete this.timers[timerType];
        }
    },


    block: function (reason) {
        if (this.blockedReasons.length === 0) {
            // Construct the blockUI adapter via the theme's behaviour
            // contract (bootstrap5 ships a CSS-only overlay, metronic_8
            // wraps KTBlockUI). Then enter the blocked state.
            this.blocked = this.hm.behaviors.blockUI.create(this.element);
            this.blocked.block();
        }

        if (this.blockedReasons.indexOf(reason) === -1) {
            this.blockedReasons.push(reason);
        }
    },

    release: function (reason) {
        let reasonIndex = this.blockedReasons.indexOf(reason);

        if (reasonIndex > -1) {
            this.blockedReasons.splice(reasonIndex, 1);
        }

        if (this.blockedReasons.length === 0 && this.blocked !== false) {
            this.blocked.release();
            this.blocked.destroy();
            this.blocked = false;
        }
    },

    validate: function () {
        this.clearTimer('validation');
        return this.hm.validator.validateComponent(this.id);
    },

    filterHideAction: function (parentValues, value) {
        if (this.hm.helper.isString(parentValues)) {
            if (parentValues.indexOf('|') > -1) {
                parentValues = parentValues.split('|');
            } else {
                parentValues = [parentValues];
            }
        }

        let action = 'hide';

        parentValues.forEach((parentValue) => {
            if (action === 'show') {
                return true;
            }
            if (parentValue === value || parentValue === '__any__') {
                action = 'show';
            } else if (parentValue.substring(0, 2) === '!=') {
                let compareParentValue = parentValue.substring(2);

                if (compareParentValue !== value) {
                    action = 'show';
                }
            }
        });

        return action;
    },

    filterHide: function (attribute, value) {
        value = String(value);

        if (typeof this.extraAttributes[attribute] === typeof undefined) {
            return true;
        }

        let toHide = this.holder !== null ? this.holder : this.element;
        for (let i = 0; i < toHide.parentElement.classList.length; i++) {
            let className = toHide.parentElement.classList[i];
            if (className.substring(0, 4) === 'col-' || className === 'col') {
                toHide = toHide.parentElement;
                break;
            }
        }

        let extraAttribute = String(this.extraAttributes[attribute]);

        let action = this.filterHideAction(extraAttribute, value);

        if (action === 'show') {
            if (Object.hasOwn(this.hiddenByFilters, attribute)) {
                delete this.hiddenByFilters[attribute];
            }
            if (Object.getOwnPropertyNames(this.hiddenByFilters).length === 0) {
                this.hm.helper.showElement(toHide);
                this.isHidden = false;
                this.notSubmittable = false;
            }
        } else {
            this.hiddenByFilters[attribute] = value;
            this.hm.helper.hideElement(toHide);
            this.isHidden = true;
            this.notSubmittable = true;
        }

        this.filteredBy[attribute] = value;

        let event = new Event('change');
        this.element.dispatchEvent(event);

        return action;
    },

    getTemplate: function (template) {
        return this.hm.helper.getTemplate(template, typeof this.subelements.mainHolder !== typeof undefined ? this.subelements.mainHolder : this.element);
    },

    hasZAttribute: function (attribute) {
        let zitAttribute = 'zit' + this.hm.helper.ucfirst(attribute);
        return typeof this.element.dataset[zitAttribute] !== typeof undefined;
    },

    readZAttribute: function (attribute, defaultValue) {
        let zitAttribute = 'zit' + this.hm.helper.ucfirst(attribute);

        if (this.hasZAttribute(attribute)) {
            return this.hm.helper.parseJson(this.element.dataset[zitAttribute]);
        } else if (typeof defaultValue !== typeof undefined) {
            return defaultValue;
        } else {
            this.hm.warn('zit attribute missing', attribute, this, this.element);
        }
    },

    readZAttributes: function () {
        for (let dataProperty in this.element.dataset) {
            if (dataProperty.substring(0, 3) === 'zit') {
                let property = this.hm.helper.lcfirst(dataProperty.substring(3));

                if (Object.hasOwn(this, property)) {
                    this[property] = this.hm.helper.parseJson(this.element.dataset[dataProperty]);
                }
            }
        }
    },

    hasAttribute: function (attribute) {
        return this.hm.helper.hasAttribute(this.element, attribute);
    },

    readAttribute: function (attribute) {
        return this.hm.helper.readAttribute(this.element, attribute);
    },

    getValue: function () {
        if (this.isHidden && this.hiddenValue !== false) {
            return this.hiddenValue;
        }

        return this.getElementValue();
    },

    getElementValue: function () {
        return this.element.value;
    },

    setValue: function (value) {
        this.setElementValue(value);
    },

    setElementValue: function (value) {
        this.element.value = value;
        this.dispatchChangeEvents();
    },

    dispatchChangeEvents: function () {
        this.changeEvents.forEach((eventName) => {
            let event = new Event(eventName);
            this.element.dispatchEvent(event);
        });
    },

    showSub: function (subelement, show = true) {
        this.hm.helper.showElement(this.subelements[subelement], show);
    },

    hideSub: function (subelement) {
        this.hm.helper.hideElement(this.subelements[subelement]);
    },

    toggleSub: function (subelement) {
        this.hm.helper.hideElement(this.subelements[subelement], 'toggle');
    },

    disable: function () {
        this.element.disabled = true;
    },

    enable: function () {
        this.element.disabled = false;
    },

    isDisabled: function () {
        return typeof this.element.disabled !== typeof undefined && this.element.disabled;
    },

    removeSubcomponents: function () {

    },

    elementName: function () {
        return this.htmlElementName ? this.htmlElementName : this.element.name;
    },

    elementKey: function () {
        let key = false;
        let elementName = this.elementName();

        if (typeof elementName !== typeof undefined) {
            let oBraketIndex = elementName.indexOf('[');

            if (oBraketIndex >= 0) {
                key = elementName.substring(oBraketIndex + 1, elementName.length - 1);
            }
        }

        return key;
    },

    formPostData: function (formPostData) {
        let value = null;

        if (!this.isDisabled()) {
            value = this.getValue();
        }

        let elementName = this.elementName();

        if (typeof elementName === typeof undefined) {
            this.hm.log('formPostData with undefined name', this.id, elementName, value);
        }

        if (value !== null && typeof elementName !== typeof undefined) {
            formPostData = this.hm.helper.formPostData(formPostData, elementName, value);
        }

        return formPostData;
    }
});

module.exports = component;